
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/region/facility/charnel",
      function () {
        return require("private-next-pages/region/facility/charnel/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/region/facility/charnel"])
      });
    }
  